export default __webpack_public_path__ + "static/media/Leads.c497632b.svg";